module.exports = __webpack_public_path__ + "media/images/sun-2070417fbe2041df8411b5a673d84910.svg";